import template from './employee_import_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class EmployeeImportHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EmployeeImportHelpPage
{
	constructor (bindings) {
		this.viewModel = new EmployeeImportHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

// Register the dialog
export default {
	name: 'EmployeeImportHelp',
	dialog_class: EmployeeImportHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employee_import_help',
	provider: 'ps'
};
